import React, { useState } from 'react';
import { useContactForm } from '../../hooks/useContactForm';

const initialFormData = {
  name: '',
  company: '',
  role: '',
  email: '',
  currentSituation: '',
  website: '',
};

const ContactForm = () => {
  const [formData, setFormData] = useState(initialFormData);
  const { status, errorMessage, submitForm, isLoading, isSuccess } = useContactForm();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await submitForm(formData);
    if (result.success) setFormData(initialFormData);
  };

  if (isSuccess) {
    return (
      <div className="form-success">
        <h3>Thank you.</h3>
        <p>We’ll be in touch within 24 hours.</p>
      </div>
    );
  }

  return (
    <form className="form-stack" onSubmit={handleSubmit}>
      <input
        type="text"
        name="website"
        tabIndex="-1"
        autoComplete="off"
        aria-hidden="true"
        value={formData.website}
        onChange={handleChange}
        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
      />
      <div className="form-row">
        <div className="field">
          <label className="field__label" htmlFor="f-name">— Your name *</label>
          <input
            className="field__input"
            id="f-name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            placeholder="First and last"
            required
          />
        </div>
        <div className="field">
          <label className="field__label" htmlFor="f-co">— Company</label>
          <input
            className="field__input"
            id="f-co"
            name="company"
            type="text"
            value={formData.company}
            onChange={handleChange}
            placeholder="Trading name"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="field">
          <label className="field__label" htmlFor="f-role">— Role</label>
          <input
            className="field__input"
            id="f-role"
            name="role"
            type="text"
            value={formData.role}
            onChange={handleChange}
            placeholder="What you are responsible for"
          />
        </div>
        <div className="field">
          <label className="field__label" htmlFor="f-email">— Email *</label>
          <input
            className="field__input"
            id="f-email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="you@company.com"
            required
          />
        </div>
      </div>

      <div className="field">
        <label className="field__label" htmlFor="f-msg">— What is going on *</label>
        <textarea
          className="field__textarea"
          id="f-msg"
          name="currentSituation"
          value={formData.currentSituation}
          onChange={handleChange}
          placeholder="The pattern you keep running into. The thing that should have been resolved by now."
          required
        />
      </div>

      {status === 'error' && <div className="form-error">{errorMessage}</div>}

      <div className="form-actions">
        <button
          type="submit"
          className="btn btn--primary"
          disabled={isLoading}
          aria-disabled={isLoading}
        >
          {isLoading ? 'Sending…' : 'Send'} <span className="arrow"></span>
        </button>
        <span className="form-privacy">
          Used only to respond. Not shared, not used for marketing.
        </span>
      </div>
    </form>
  );
};

export default ContactForm;
